import { Avatar, Drawer, Form, Popconfirm } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import GiftDetails from "./Details";
import Empty from "../common/Empty";
import AddGift from "./AddGiftVoucherList";
import { responseNotification } from "../../utils/notify";
import moment from "moment";

const GiftVoucherList = () => {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [giftData, setGiftData] = useState({
    loading: false,
    data: null,
  });

  const [selectedGift, setSelectedGift] = useState(undefined);
  const [selectedGiftForEdit, setSelectedGiftForEdit] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const fetchRef = useRef(null);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setType("JC_MART");
    form.resetFields();
  };

  const getGiftVoucher = useCallback(async () => {
    setGiftData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(`${encodedUri}/admin/gift`, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setGiftData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setGiftData({ loading: false, data: [] });
        console.error("Gift: Error", err);
      });
  }, []);

  useEffect(() => {
    getGiftVoucher();
  }, [getGiftVoucher]);

  const showPopconfirm = (id) => {
    setVisible(id);
  };

  const handleCancel = () => {
    setVisible(undefined);
  };

  useEffect(() => {
    if (visible) {
      setSelectedGift(undefined);
      setSelectedGiftForEdit(undefined);
    }
  }, [selectedGift, selectedGiftForEdit]);

  useEffect(() => {
    setSelectedGift(undefined);
    setSelectedGiftForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedGift(null);
    setSelectedGiftForEdit(null);
    getGiftVoucher();
  };

  return (
    <React.Fragment>
      <TopHeading
        total={giftData?.data?.totalElements}
        refetch={getGiftVoucher}
      />

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Created Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>From Amount</span>
                  </div>
                  <div className="single-product-heading">
                    <span>To Amount</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {giftData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {giftData?.data?.gifts?.length ? (
                    giftData?.data?.gifts?.map((gift, index) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedGift(gift)}
                        >
                          {/* <div className="single-product major">
                            <Avatar
                              shape="square"
                              size={45}
                              src={gift?.product?.productImage}
                              className="mr-3"
                            />
                            <span className="name">{gift?.product?.name}</span>
                          </div> */}
                          <div className="single-product">
                            <span className="name">
                              {moment(gift?.createdAt).format("lll")}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">{gift?.fromAmount}</span>
                          </div>
                          <div className="single-product">
                            <span className="name">{gift?.toAmount}</span>
                          </div>

                          <div className="single-product">
                            <span
                              className={`radius-btn ${gift?.active?.toLowerCase()}-btn`}
                            >
                              {gift?.active}
                            </span>
                          </div>

                          <div className="single-product">
                            <button
                              className="btn btn-sm btn-warning mx-1"
                              onClick={() => setSelectedGiftForEdit(gift)}
                            >
                              <EditOutlined />
                            </button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Gift" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedGiftForEdit ? "Change Gift Item" : "Gift Details"}
            width={selectedGiftForEdit ? 500 : 500}
            onClose={() => {
              setSelectedGift(null);
              setSelectedGiftForEdit(null);
            }}
            visible={selectedGift || selectedGiftForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedGiftForEdit ? (
              <AddGift
                visibleData={selectedGiftForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <GiftDetails GiftDetails={selectedGift} />
            )}
          </Drawer>

          <PaginationTwo
            {...giftData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default GiftVoucherList;
